export const LOCATIONS = [
  {
    slug: "hannover-mitte",
    name: "Hannover Mitte",
    region: "Hannover",
    description: "Sicherheitsdienste im Herzen von Hannover – für Geschäfte, Büros, Hotels und öffentliche Einrichtungen in der Innenstadt.",
    highlights: ["City-Objekte", "Einzelhandel", "Gastronomie", "Bürogebäude"],
  },
  {
    slug: "vahrenwald-list",
    name: "Vahrenwald-List",
    region: "Hannover",
    description: "Zuverlässiger Sicherheitsdienst für den beliebten Stadtteil Vahrenwald-List mit Wohnanlagen, Gewerbe und Veranstaltungsorten.",
    highlights: ["Wohnanlagen", "Gewerbegebiete", "Kultureinrichtungen", "Nahversorgung"],
  },
  {
    slug: "bothfeld-vahrenheide",
    name: "Bothfeld-Vahrenheide",
    region: "Hannover",
    description: "Sicherheitsleistungen für Bothfeld-Vahrenheide – vom Objektschutz bis zur Baustellenbewachung im Norden Hannovers.",
    highlights: ["Wohnquartiere", "Gewerbeparks", "Baustellen", "Bildungseinrichtungen"],
  },
  {
    slug: "buchholz-kleefeld",
    name: "Buchholz-Kleefeld",
    region: "Hannover",
    description: "Professionelle Sicherheit für Buchholz-Kleefeld – Revierdienst, Objektschutz und Veranstaltungssicherheit.",
    highlights: ["Wohngebiete", "Sportstätten", "Grünanlagen", "Gewerbeobjekte"],
  },
  {
    slug: "misburg-anderten",
    name: "Misburg-Anderten",
    region: "Hannover",
    description: "Sicherheitsdienst für das Industriegebiet Misburg-Anderten – Werkschutz, Baustellenbewachung und Logistiksicherheit.",
    highlights: ["Industriegebiete", "Logistikzentren", "Produktionsstätten", "Baustellen"],
  },
  {
    slug: "kirchrode-bemerode-wuelferode",
    name: "Kirchrode-Bemerode-Wülferode",
    region: "Hannover",
    description: "Sicherheitsdienstleistungen für Kirchrode, Bemerode und Wülferode – Wohnsicherheit und Gewerbeschutz.",
    highlights: ["Expo-Gelände", "Messesicherheit", "Wohnquartiere", "Gewerbeobjekte"],
  },
  {
    slug: "suedstadt-bult",
    name: "Südstadt-Bult",
    region: "Hannover",
    description: "Sicherheitslösungen für die Südstadt-Bult – Klinikgelände, Wohngebiete und gehobene Objekte.",
    highlights: ["Klinikgelände", "Wohngebiete", "Bürokomplexe", "Bildungseinrichtungen"],
  },
  {
    slug: "doehren-wuelfel",
    name: "Döhren-Wülfel",
    region: "Hannover",
    description: "Sicherheitsdienst für Döhren-Wülfel – Gewerbegebiete, Wohnanlagen und Einzelhandel im Süden Hannovers.",
    highlights: ["Einkaufszentren", "Gewerbegebiete", "Wohnanlagen", "Freizeiteinrichtungen"],
  },
  {
    slug: "ricklingen",
    name: "Ricklingen",
    region: "Hannover",
    description: "Professionelle Sicherheit für Ricklingen – vom Revierdienst bis zum Veranstaltungsschutz.",
    highlights: ["Wohngebiete", "Sportanlagen", "Schwimmbäder", "Gewerbeobjekte"],
  },
  {
    slug: "linden-limmer",
    name: "Linden-Limmer",
    region: "Hannover",
    description: "Sicherheitsdienstleistungen für Linden-Limmer – Veranstaltungssicherheit, Objektschutz und Revierdienst.",
    highlights: ["Kulturveranstaltungen", "Gastronomie", "Wohnquartiere", "Gewerbeflächen"],
  },
  {
    slug: "ahlem-badenstedt-davenstedt",
    name: "Ahlem-Badenstedt-Davenstedt",
    region: "Hannover",
    description: "Sicherheitsdienst für Ahlem, Badenstedt und Davenstedt – Industrie, Gewerbe und Wohnanlagen.",
    highlights: ["Industriegebiete", "Wohnquartiere", "Gewerbegebiete", "Infrastruktur"],
  },
  {
    slug: "herrenhausen-stoecken",
    name: "Herrenhausen-Stöcken",
    region: "Hannover",
    description: "Sicherheitsleistungen für Herrenhausen-Stöcken – Messegelände, Industrie und Veranstaltungsorte.",
    highlights: ["Messegelände", "Industrieparks", "Veranstaltungsorte", "Gewerbeobjekte"],
  },
  {
    slug: "hannover-nord",
    name: "Hannover Nord",
    region: "Hannover",
    description: "Sicherheitsdienst für den Norden Hannovers – Flughafennähe, Gewerbegebiete und Wohnanlagen.",
    highlights: ["Flughafennähe", "Gewerbegebiete", "Logistik", "Wohnquartiere"],
  },
  {
    slug: "bremen",
    name: "Bremen",
    region: "Bremen",
    description: "Deutsche B&S bietet professionelle Sicherheitsdienste in Bremen – von Objektschutz über Veranstaltungssicherheit bis hin zu Revierdiensten.",
    highlights: ["Innenstadtobjekte", "Hafengebiete", "Messesicherheit", "Industrieanlagen"],
  },
  {
    slug: "oldenburg",
    name: "Oldenburg",
    region: "Niedersachsen",
    description: "Sicherheitsdienstleistungen in Oldenburg und Umgebung – zuverlässig, professionell und individuell abgestimmt.",
    highlights: ["Stadtzentrum", "Universitätsgelände", "Gewerbeparks", "Veranstaltungen"],
  },
  {
    slug: "hamburg",
    name: "Hamburg",
    region: "Hamburg",
    description: "Professioneller Sicherheitsdienst in Hamburg – Objektschutz, Veranstaltungssicherheit und Revierdienste in der Hansestadt.",
    highlights: ["Hafen & Logistik", "Innenstadt", "Messen & Events", "Gewerbeobjekte"],
  },
  {
    slug: "wolfsburg",
    name: "Wolfsburg",
    region: "Niedersachsen",
    description: "Sicherheitsdienst in Wolfsburg – Werkschutz, Baustellenbewachung und Objektschutz für Industrie und Gewerbe.",
    highlights: ["Industriegebiete", "Werksgelände", "Veranstaltungen", "Gewerbeobjekte"],
  },
  {
    slug: "braunschweig",
    name: "Braunschweig",
    region: "Niedersachsen",
    description: "Zuverlässige Sicherheitsleistungen in Braunschweig – Objektschutz, Revierdienst und Eventsicherheit.",
    highlights: ["Innenstadt", "Forschungszentren", "Gewerbegebiete", "Kultur & Events"],
  },
];
